import { FC, ReactNode, useEffect, useState } from "react";
import { SiteType, TeamContext } from "../../types/common";
import { TournamentSelector } from "../../components/TournamentSelector";
import { StatsTournamentSelectorsDto, StatsType, TournamentStageType } from "../../types/stats";
import { getSelectors, getTournamentStages } from "../../api/transport/statsTransport";
import { StatsSelector } from "./StatsSelector";
import { getSiteByTeamCode, setDocumentTitle } from "../../utils";

interface StatsPageProps {
    teamContext?: TeamContext;
    pageType?: StatsType;
    children?: ReactNode;
    title?: string;
    onTournamentChange?: (tournamentUuid: string, seasonUuid: string, legacyTournament?: number, legacySeason?: number) => void;
}

export const StatsPage: FC<StatsPageProps> = ({
    teamContext,
    pageType,
    onTournamentChange,
    children,
    title,
}) => {
    const [selectorOptions, setSelectorOptions] = useState<StatsTournamentSelectorsDto>();
    const [menuItems, setMenuItems] = useState<StatsType[]>([]);

    useEffect(() => {
        getSelectors(teamContext).then((data) => {
            setSelectorOptions(data);
        }).catch(() => {
            setSelectorOptions(undefined);
        });
    }, []);

    useEffect(() => {
        let pageName = 'Турнирная таблица';
        switch(pageType) {
            case StatsType.CALENDAR:
                pageName = 'Календарь';
                break;
            case StatsType.PLAYER:
                pageName = 'Статистика';
                break;
            case StatsType.SUMMARY_TABLE:
                pageName = 'Общий зачёт';
                break;
        }
        let siteName = 'Официальный сайт ФК «Родина»';
        if (getSiteByTeamCode(teamContext) === SiteType.LEGACY_ACADEMY) {
            siteName = 'Официальный сайт Академия «Родина»';
        }

        setDocumentTitle(`${pageName} - ${siteName}`);
    }, [pageType, teamContext]);

    if (!selectorOptions) {
        return null;
    }

    const onTournamentSelect = async (tournamentUuid: string, seasonUuid: string, legacyTournament?: number, legacySeason?: number) => {
        if (onTournamentChange) {
            onTournamentChange(tournamentUuid, seasonUuid, legacyTournament, legacySeason);
        }
        if (!tournamentUuid) {
            return;
        }

        const menu = [StatsType.CALENDAR];

        const stages = await getTournamentStages(tournamentUuid);

        if (stages?.filter(s => s.type === TournamentStageType.REGULAR)?.length) {
            menu.push(StatsType.TOURNAMENT_TABLE);
        }
        menu.push(StatsType.PLAYER);

        setMenuItems(menu);
    }

    return (
        <div className="py-4 max-w-[1024px] mx-auto min-h-[500px]">
            {title && <h1 className="py-4 sm:pb-8 text-2xl sm:text-3xl font-semibold text-center">{title}</h1>}
            <div className="flex flex-col items-end sm:flex-row sm:items-end justify-between max-w-full pb-4">
                <div className="mx-auto">
                    <TournamentSelector
                        selectorOptions={selectorOptions}
                        onSelect={onTournamentSelect}
                    />
                </div>
                <div className="py-2 px-3 sm:p-0 min-w-1/2 fixed bottom-24 sm:bottom-12 z-10 left-0 right-0 mx-auto">
                    <StatsSelector
                        items={menuItems}
                        selected={pageType}
                        teamContext={teamContext}
                    />
                </div>
            </div>
            <div className="w-full">
                {children}
            </div>
        </div>
    )
}